<template>
  <v-row class="px-4 pt-3 pb-4 details-proposal__card">
    <v-col cols="12">
      <p class="primary--text font-weight-bold mb-2">
        Outras Informações
      </p>
    </v-col>
    <v-col cols="12" class="details-proposal__item-auto">
      <v-row class="pa-4">
        <v-col cols="12">
          <p
            class="caption darkBluishGray--text mb-2 font-weight-medium details-proposal__text-height"
          >
            Seguradora:
            <label class="details-proposal__value primary--text">
              {{ insuranceCompany }}
            </label>
          </p>
          <p
            class="caption darkBluishGray--text mb-2 font-weight-medium details-proposal__text-height"
          >
            Seguro:
            <label class="details-proposal__value primary--text">
              {{ form.tipo_seguro.name }}
            </label>
          </p>
          <p
            class="caption darkBluishGray--text mb-2 font-weight-medium details-proposal__text-height"
          >
            Regulação de Sinistros:
            <label class="details-proposal__value primary--text">
              {{ form.tipo_reivindicacao.name }}
            </label>
          </p>
          <p
            class="caption darkBluishGray--text mb-2 font-weight-medium details-proposal__text-height"
          >
            Produtividade Garantida (sc/ha):
            <label class="details-proposal__value primary--text">
              {{ form.producao_garantida }}
            </label>
          </p>
          <p
            class="caption darkBluishGray--text mb-2 font-weight-medium details-proposal__text-height"
          >
            Área Total Aceita:
            <label class="details-proposal__value primary--text">
              {{ form.area_segurada }}
            </label>
          </p>
          <p
            class="caption darkBluishGray--text mb-2 font-weight-medium details-proposal__text-height"
            v-if="isProductivity"
          >
            Valor da Saca:
            <label class="details-proposal__value primary--text">
              {{ asMoneyString(form.custo_por_saca) }}
            </label>
          </p>
          <p
            class="caption darkBluishGray--text mb-2 font-weight-medium details-proposal__text-height"
            v-if="!isProductivity"
          >
            Valor por Hectare:
            <label class="details-proposal__value primary--text">
              {{ asMoneyString(form.custo_por_hectare) }}
            </label>
          </p>
          <p
            class="caption darkBluishGray--text mb-2 font-weight-medium details-proposal__text-height"
          >
            Importância Segurada:
            <label class="details-proposal__value primary--text">
              {{ asMoneyString(form.importancia_segurada) }}
            </label>
          </p>
          <p
            class="caption darkBluishGray--text mb-2 font-weight-medium details-proposal__text-height"
          >
            Prêmio Total:
            <label class="details-proposal__value primary--text">
              {{ asMoneyString(form.custo_total) }}
            </label>
          </p>
          <p
            class="caption darkBluishGray--text mb-2 font-weight-medium details-proposal__text-height"
          >
            Subvenção Federal:
            <label class="details-proposal__value primary--text">
              {{ asMoneyString(form.subvencao_federal) }}
            </label>
          </p>
          <p
            class="caption darkBluishGray--text mb-2 font-weight-medium details-proposal__text-height"
          >
            Prêmio Final ao Produtor:
            <label class="details-proposal__value primary--text">
              {{ asMoneyString(form.custo_produtor) }}
            </label>
          </p>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import DocumentsMixin from "@/mixins/DocumentsMixin";
import { asMoneyString, formatIsoDateToDDMMYYYY } from "@/utils/formats.js";

export default {
  name: "QuotationProposalAgricolaInformation",
  mixins: [DocumentsMixin],
  data() {
    return {
      asMoneyString,
      formatIsoDateToDDMMYYYY,
      closeTable: false
    };
  },
  methods: {
    closeTableBillingFile() {
      return (this.closeTable = true);
    }
  },
  computed: {
    hasAditionalCoverage() {
      return this.form.tipo_cobertura?.id === "basica_replantio";
    },
    isProductivity() {
      return this.form.tipo_seguro.id == "produtividade";
    },
    insuranceCompany() {
      return this.form.seguradora?.nome;
    },
    insuranceType() {
      return this.form.tipo_seguro?.nome;
    },
    claimType() {
      return this.form.tipo_reivindicacao?.nome;
    }
  },
  props: {
    form: {
      type: Object
    },
    isPolicy: {
      type: Boolean,
      default: false
    }
  }
};
</script>
